// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"4648d869","36":"d3b3e8b5","307":"cc1d3c5b","314":"a9a464af","532":"6bbc7cc1","541":"e51c430b","587":"3730aa16","687":"c1b2b620","797":"e5685694","941":"a4b955fb"}[chunkId] + ".chunk.js";
};